import { useEffect, useState } from 'react'
import { ItemOption } from 'components/FormInputSelect'
import identificationService from 'services/identification.service'
import {
  hearingIdentificationInit,
  HearingIdentificationType,
} from 'types/hearing-identification.type'
import addressService from 'services/address.service'
import { useBackdrop } from 'contexts/backdrop.context'
import { useSnackBar } from 'contexts/snackbar.context'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { HttpErrorType } from 'types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'

export const useHearingIdentification = (hearingId?: string) => {
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const { showSnackBar } = useSnackBar()

  const [hearingIdentification, setHearingIdentification] =
    useState<HearingIdentificationType | null>(null)
  const [naturalnessStateOptions, setNaturalnessStateOptions] = useState<ItemOption[]>([])
  const [naturalnessCityOptions, setNaturalnessCityOptions] = useState<ItemOption[]>([])

  useEffect(() => {
    ;(async () => {
      handleBackdropOpen()
      await getIdentification().finally(() => handleBackdropClose())
      await addressService.getAllFullNameStates().then((response) => {
        setNaturalnessStateOptions(response.data)
      })
    })()
  }, [])

  const getIdentification = async () => {
    await identificationService.getById(hearingId).then((response) => {
      const initialValues = response.data ? response.data : hearingIdentificationInit
      setHearingIdentification(initialValues)
    })
  }

  const fillNaturalnessCity = async (naturalnessStateIdValue?: string | null): Promise<void> => {
    if (!naturalnessStateIdValue || naturalnessStateIdValue === '0') return
    await addressService.getAllCitiesByStateId(naturalnessStateIdValue).then((response) => {
      setNaturalnessCityOptions(response.data)
    })
  }

  const saveIdentification = async (data: HearingIdentificationType): Promise<void> => {
    if (hearingId) {
      handleBackdropOpen()
      await identificationService
        .save(hearingId, data)
        .then(async () => {
          showSnackBar(SystemMessages.MESSAGE_001, 'success')
        })
        .catch((error: HttpErrorType) => {
          showSnackBar(errorMessage(error), errorColor(error))
        })
        .finally(() => handleBackdropClose())

      //await getIdentification()
    }
  }

  return {
    hearingIdentification,
    naturalnessStateOptions,
    naturalnessCityOptions,

    fillNaturalnessCity,
    saveIdentification,
  }
}
